import { useEffect, useState } from "react";
import { isLoggedIn } from "api/coachAuth";
import { TaskType } from "api";
import { useRecoilState, useRecoilValue } from "recoil";
import { taskListAtom } from "recoil/taskListAtom";
import { userAtom } from "recoil/userAtom";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import { menuKeyType } from "./NestedList";
import ActivityList from "./ActivityList";

export const freeTaskList = ["0-0-A", "0-10-A", "0-1", "0-2"];
export const onboardingTaskId = "0-0-A";

export default function LearningActivityList({
  data,
  dataUpdatedAt,
}: {
  data: TaskType[];
  dataUpdatedAt?: number;
}) {
  const { isNotStarted } = useSubscriptionStatus();

  const [taskListState, setTaskListState] = useRecoilState(taskListAtom);

  const userState = useRecoilValue(userAtom);

  const isCoach = isLoggedIn(userState) && userState?.role !== "patient";

  const [listData, setListData] = useState<
    | {
        listTitle: string;
        taskList: TaskType[];
        menuKey: menuKeyType;
        initiallyOpen?: boolean;
      }[]
    | undefined
  >();

  useEffect(() => {
    if (data) {
      // 0-10-A, 0-11-A의 lastDoneAt 상태 확인
      const task_0_10_A = data.find((t) => t.taskId === "0-10-A");
      const task_0_11_A = data.find((t) => t.taskId === "0-11-A");

      const updatedData = data.map((each) => {
        // 기본 잠금 로직 (구독 관련)
        let isLocked =
          !isCoach && isNotStarted
            ? !freeTaskList.includes(each.taskId)
            : each.isLocked;

        // 순차 잠금 로직 추가
        if (each.taskId === "0-11-A") {
          // 0-10-A가 완료되지 않았으면 잠금
          isLocked = !task_0_10_A?.lastDoneAt;
        } else if (each.taskId === "0-20-A") {
          // 0-11-A가 완료되지 않았으면 잠금
          isLocked = !task_0_11_A?.lastDoneAt;
        }

        return { ...each, isLocked };
      });

      setTaskListState(updatedData);
    }
  }, [data, dataUpdatedAt]);

  useEffect(() => {
    if (taskListState && taskListState.length > 0) {
      const todoList = taskListState.filter((element) => element.isOpen);
      setListData([
        ...(todoList.length > 0
          ? [
              {
                listTitle: "오늘의 활동",
                taskList: todoList,
                menuKey: "taskList_open" as menuKeyType,
                initiallyOpen: true,
              },
            ]
          : []),
      ]);
    }
  }, [taskListState]);

  return (
    <>
      <ActivityList
        title={"배움활동지"}
        isInitialLoading={!data}
        listData={listData}
      />
    </>
  );
}
